(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/prescript.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.tur = svs.tur || {};
  svs.tur.startSubscription = svs.tur.startSubscription || {};
  svs.tur.start_subscription = svs.tur.start_subscription || {};
  svs.tur.start_subscription.models = svs.tur.start_subscription.models || {};
  svs.tur.start_subscription.behaviors = svs.tur.start_subscription.behaviors || {};
  svs.tur.start_subscription.views = svs.tur.start_subscription.views || {};
  svs.tur.start_subscription.utils = svs.tur.start_subscription.utils || {};
  svs.tur.start_subscription.logger = svs.core.log.getLogger('component:start_subscription');

  svs.tur.start_subscription.constants = {
    STATUS: {
      CREATED: 1,
      PAUSED: 3
    },
    ENABLE_TYPE: {
      ANNOUNCEMENT: 'ANNOUNCEMENT',
      ENTRY: 'ENTRY'
    },
    PAYMENT_TYPE: {
      BANK_CARD: {
        TYPE: 'BANK_CARD',
        TEXT: 'bankkort'
      },
      AUTOGIRO: {
        TYPE: 'AUTOGIRO',
        TEXT: 'autogiro'
      }
    }
  };
})(Backbone, _, svs);


 })(window);